// extracted by mini-css-extract-plugin
module.exports = {"grouping":"TitleChip_grouping__-Yi6G","icon":"TitleChip_icon__V3GDq","text":"TitleChip_text__6OwqZ","secondaryText":"TitleChip_secondaryText__2odvd"};